/**
 * 功能列表服务
 */
"use strict";
angular.module("historyHotAdminServiceMoudle", [
	"checkModule",  //查看详情
    "delModule",  //删除规则
    "giveupModule",  //放弃添加
    "helpModule",  //帮助
    "addhotModule", //添加热点
    "edithotModule", //添加热点
]).
factory("historyHotAdminService", ["$modal","$q", function($modal, $q) {
    return {
        check: function(id) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./commandMonitor/publicOpinionMgrZj/historyHotAdmin/service/check/check_tpl.html",
                windowClass: "m-checkbox",
                backdrop: false,
                resolve: {
                    item: function() {
                        return {
                            id: id,
                            //type: type
                        };
                    },
                    // confirmBtn: function() {
                    //     return confirmBtn;
                    // }
                },
                controller: "checkCtrl"
            });
            modalInstance.result.then(function(data) {
                deffer.resolve(data);
            }, function() {

            });
            return deffer.promise;
        },
        del: function(id) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./commandMonitor/publicOpinionMgrZj/historyHotAdmin/service/del/del_tpl.html",
                windowClass: "m-deletebox",
                backdrop: false,
                resolve: {
                    item: function() {
                        return {
                            id: id,
                            //type: type
                        };
                    },
                    // confirmBtn: function() {
                    //     return confirmBtn;
                    // }
                },
                controller: "delCtrl"
            });
            modalInstance.result.then(function(data) {
                deffer.resolve(data);
            }, function() {

            });
            return deffer.promise;
        },
        help: function(id) {
            var modalInstance = $modal.open({
                templateUrl: "./commandMonitor/publicOpinionMgrZj/historyHotAdmin/service/help/help_tpl.html",
                windowClass: "m-helpbox",
                backdrop: false,
                resolve: {
                    item: function() {
                        return {
                            id: id,
                            //type: type
                        };
                    },
                    // confirmBtn: function() {
                    //     return confirmBtn;
                    // }
                },
                controller: "helpCtrl"
            });
            modalInstance.result.then(function(result) {
            });
        },
        addhot: function() {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./commandMonitor/publicOpinionMgrZj/historyHotAdmin/service/addhot/addhot_tpl.html",
                windowClass: "m-addhotbox",
                backdrop: false,
                resolve: {
                    // item: function() {
                    //     return {
                    //         id: id,
                    //         //type: type
                    //     };
                    // },
                    // confirmBtn: function() {
                    //     return confirmBtn;
                    // }
                },
                controller: "addhotCtrl"
            });
            modalInstance.result.then(function(data) {
                deffer.resolve(data);
            }, function() {

            });
            return deffer.promise;
        },
        edithot: function() {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./commandMonitor/publicOpinionMgrZj/historyHotAdmin/service/edithot/edithot_tpl.html",
                windowClass: "m-edithotbox",
                backdrop: false,
                resolve: {
                    // item: function() {
                    //     return {
                    //         id: id,
                    //         //type: type
                    //     };
                    // },
                    // confirmBtn: function() {
                    //     return confirmBtn;
                    // }
                },
                controller: "edithotCtrl"
            });
            modalInstance.result.then(function(data) {
                deffer.resolve(data);
            }, function() {

            });
            return deffer.promise;
        },
        giveup: function() {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./commandMonitor/publicOpinionMgrZj/historyHotAdmin/service/giveup/giveup_tpl.html",
                windowClass: "m-giveupbox",
                backdrop: false,
                resolve: {
                    // item: function() {
                    //     return {
                    //         id: id,
                    //         type: type
                    //     };
                    // },
                    // confirmBtn: function() {
                    //     return confirmBtn;
                    // }
                },
                controller: "giveupCtrl"
            });
            modalInstance.result.then(function(data) {
                deffer.resolve(data);
            }, function() {

            });
            return deffer.promise;
        }
    };
}]);